import { useQuery, useApolloClient } from '@apollo/react-hooks';
import { useDispatch } from 'react-redux';

export default function useData(q) {
  const query = useQuery(q);
  const client = useApolloClient();
  const dispatch = useDispatch();
  return { client, dispatch, data: query.data };
}
